import "./PrintDummy.scss";

export function PrintDummy() {
  return <div className="print-dummy-container" />;
}
